import { dividerKeys } from 'ui/utils/seamly-utils'
import DefaultDivider from './variants/default'
import NewTranslationDivider from './variants/new-translation'

const Variants = {
  default: DefaultDivider,
  [dividerKeys.new_translation]: NewTranslationDivider,
}

const Divider = ({ event, ...props }) => {
  const Component =
    Variants[dividerKeys[event.payload.body.subtype]] || Variants.default
  return <Component event={event} {...props} />
}

export default Divider
